import { render, staticRenderFns } from "./AmlModal.vue?vue&type=template&id=3310dd8b&scoped=true"
import script from "./AmlModal.vue?vue&type=script&lang=js"
export * from "./AmlModal.vue?vue&type=script&lang=js"
import style0 from "./AmlModal.vue?vue&type=style&index=0&id=3310dd8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3310dd8b",
  null
  
)

export default component.exports